import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Layout from '../views/Layout.vue'
import TrainingList from '../views/TrainingList.vue'
import CourseCatalog from '../views/CourseCatalog.vue'
import VideoStudy from '../views/VideoStudy.vue'
import { getToken } from '../utils/auth'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: Login, meta: { title: '登录' } },
  {
    path: '/',
    component: Layout,
    redirect: '/training',
    children: [
      { path: 'training', component: TrainingList, meta: { title: '培训列表', requiresAuth: true } },
      { path: 'course', component: CourseCatalog, meta: { title: '课程目录', requiresAuth: true } },
      { path: 'video', component: VideoStudy, meta: { title: '视频学习', requiresAuth: true } }
    ]
  },
  { path: '*', redirect: '/training' }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = (to.meta && to.meta.title) || '安全培训学习平台'
  if (to.matched.some(r => r.meta && r.meta.requiresAuth) && !getToken()) {
    next({ path: '/login' })
  } else {
    next()
  }
})

export default router
